import {
  apiClient,
  ApiClientConfig,
  PaginatedRequestParams,
  PaginatedResponse,
} from 'api';
import { axiosInstance } from 'api/axios-instance';
import { Gender, User } from 'types';

export interface UserListParams extends PaginatedRequestParams {
  full_user_name?: string;
  phone_number?: string;
  roles?: string[];
  company_id?: string;
  created_at_from?: string; // ISO8601_FORMAT
  created_at_to?: string; // ISO8601_FORMAT
}

export type CreateUserDTO = {
  UserName?: string;
  Email?: string | null;
  RoleId: string;
};

export type UpdateUserDTO = {
  company_id?: string;
  email?: string | null;
  first_name?: string;
  gender?: Gender | null;
  id: string;
  last_name?: string;
  password?: string;
  phone_number?: string;
  is_active?: boolean;
  role?: string;
};

export type UserResponse = PaginatedResponse<User>;

export const UserApiService = () => {
  const createUser = async (formData: FormData) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_BASE_URL;
    const response = await axiosInstance.post(
      `${baseURL}/ClientUser/CreateUser`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return response.data;
  };

  const getUser = async (id: string, callConfig?: Partial<ApiClientConfig>) => {
    const response = await apiClient<User>({
      ...callConfig,
      endpoint: `/Client/GetClientDetail/${id}`,
    });

    return response.data;
  };
  const getMenuItem = async (
    id: string,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<User>({
      ...callConfig,
      endpoint: `/Client/GetMenuList/${id}`,
    });

    return response.data;
  };
  const getUsers = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<UserResponse>({
      ...callConfig,
      endpoint: `/ClientUser/GetUserList`,
      params,
    });

    return response.data;
  };
  const getRole = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<UserResponse>({
      ...callConfig,
      endpoint: `/RoleManagement/GetRoleList`,
      params,
    });

    return response.data;
  };

  // const updateUser = async (
  //   payload: UpdateUserDTO,
  //   callConfig?: Partial<ApiClientConfig>,
  // ) => {
  //   const { id, ...data } = payload;

  //   const response = await apiClient<User>({
  //     ...callConfig,
  //     endpoint: `/admin/users/${id}`,
  //     method: 'PATCH',
  //     data,
  //   });

  //   return response.data;
  // };
  const updateUser = async (
    payload: UpdateUserDTO,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<User>({
      ...callConfig,
      endpoint: `/ClientUser/UpdateUser`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
  const updateUserSendEmailAccess = async (
    payload: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_BASE_URL;
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL}/ClientUser/UpdateUserSendEmailAccess`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
  const updateStatus = async (
    payload: UpdateUserDTO,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<User>({
      ...callConfig,
      endpoint: `/UserManagement/UpdateUserStatus`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
  const getUserClients = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_BASE_URL;
    const response = await apiClient<UserResponse>({
      ...callConfig,
      endpoint: `${baseURL}/ClientUser/GetUserList`,
      params,
    });

    return response.data;
  };
  const userManagementService = async (
    params: any, // Pass ParentId as a parameter
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_BASE_URL;
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL}/Client/GetClientUserServices`,
      params,
    });

    return response;
  };
  const getRolePermission = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `/RoleManagement/GetPermissionlist`,
      params,
    });

    return response.data;
  };
  const UploadImageProfile = async (formData: FormData) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_BASE_URL;
    const response = await axiosInstance.post(
      `${baseURL}/UserManagement/UploadUserImage`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return response.data;
  };
  const updateMail = async (formData: FormData) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_BASE_URL;
    const response = await axiosInstance.post(
      `${baseURL}/Client/UpdateEmail`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return response.data;
  };
  const ChangePasswordProfile = async (
    payload: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<User>({
      ...callConfig,
      endpoint: `/UserManagement/ChangePassword`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
  const OtpVerfiedUser = async (
    payload: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<User>({
      ...callConfig,
      endpoint: `/UserManagement/VerifyEmailOtp`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
  const updateUserMail = async (
    payload: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<User>({
      ...callConfig,
      endpoint: `/UserManagement/VerifyEmail`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
  const ProfileUpdate = async (
    payload: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<User>({
      ...callConfig,
      endpoint: `/UserManagement/UpadteUserName`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };

  return {
    createUser,
    getUser,
    getUsers,
    updateUser,
    getRole,
    getMenuItem,
    updateStatus,
    getUserClients,
    userManagementService,
    getRolePermission,
    UploadImageProfile,
    updateMail,
    ChangePasswordProfile,
    OtpVerfiedUser,
    updateUserMail,
    ProfileUpdate,
    updateUserSendEmailAccess,
  };
};
